import { Header } from '@/components/DashboardComponents'
import { useLoaderData, useNavigate } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { useMenu } from '@/components/Menu'
import { List, ListItem, ItemColumn } from '@/components/List'
import { useInmemoryStorage } from '@/hooks/useStorage'
import { shortDate } from '@/shared/utils'

export function InternalUsers() {
  const all_users = useLoaderData().data.value;
  const users = all_users.filter((u) => u.email);

  const [sort, setSort] = useInmemoryStorage("internal_users_sort", ["date_created", -1]);

  return (
    <>
      <Header title="Users"/>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <List fullPage={true} columns={[
          { name: "Name", id: "name", sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }], min_width: 250 },
          { name: "Email", width: 260, hide_order: 2 },
          { name: "Role", id: "role", width: 70, hide_order: 1, sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }] },
          { name: "Organization", id: "organization", width: 150, hide_order: 3, sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }] },
          { name: "Date created", id: "date_created", width: 110, hide_order: 0, sortable: [{ value: -1, name: "New to old", arrow: "down", default: true }, { value: 1, name: "Old to new", arrow: "up" }] },
        ]} sort={sort} setSort={setSort} menu={true}>
          {[...users].sort((a, b) => {
            if (sort[0] === "name") {
              const aName = (a.name || a.email || "").toLowerCase();
              const bName = (b.name || b.email || "").toLowerCase();
              return sort[1] === -1 ? aName.localeCompare(bName) : bName.localeCompare(aName);
            } else if (sort[0] === "role") {
              const aRole = (a.role || "").toLowerCase();
              const bRole = (b.role || "").toLowerCase();
              if (!a.role && !b.role) return 0;
              if (!a.role) return 1;
              if (!b.role) return -1;
              return sort[1] === -1 ? aRole.localeCompare(bRole) : bRole.localeCompare(aRole);
            } else if (sort[0] === "date_created") {
              return sort[1] === -1 ? b.date_created - a.date_created : a.date_created - b.date_created;
            } else if (sort[0] === "organization") {
              const aOrg = (a._organization_name || "").toLowerCase();
              const bOrg = (b._organization_name || "").toLowerCase();
              if (!a._organization_name && !b._organization_name) return 0;
              if (!a._organization_name) return 1;
              if (!b._organization_name) return -1;
              return sort[1] === -1 ? aOrg.localeCompare(bOrg) : bOrg.localeCompare(aOrg);
            }
            return 0;
          }).map((user) => <UserItem key={user._id} user={user}/>)}
        </List>
        {users.length === 0 && <GenericEmptyListPlaceholder text="No users"/>}
      </div>
    </>
  )
}

function UserItem({ user }) {
  const navigate = useNavigate();

  const menu = useMenu({
    menuItems: []
  });

  return (
    <ListItem icon="account-circle-outline" onClick={() => { navigate("/internal/users/" + user._id) }}>
      <ItemColumn>{user.name || "—"}</ItemColumn>
      <ItemColumn>{user.email}</ItemColumn>
      <ItemColumn>{user.role || "—"}</ItemColumn>
      <ItemColumn>{user._organization_name || "—"}</ItemColumn>
      <ItemColumn>{user.date_created ? shortDate(user.date_created) : "—"}</ItemColumn>
    </ListItem>
  )
}
